module.exports = __webpack_public_path__ + "static/media/flags.723494a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags.png
// module id = 69
// module chunks = 0